<template>
    <div>
        <slot :filters="filters" :loading="loading" :processresults="processResults"></slot>
    </div>
</template>

<script>
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
    name: 'CalendarFilters',
    props: {
        filters: {
            type: Array,
            required: true
        },

        canreset: {
            type: Boolean,
        },

        resetfilters: {
            type: Function,
        },

        textsearchfn: {
            type: Function,
        },

        searchtext: {
            type: String,
        },

        processresults: {
            type: Function,
            required: true,
        },

        totalresults: {
            type: Number,
        },
    },
    setup(props) {
        const filters = ref([]);
        const loading = ref(true);
        const processResults = ref(null);

        /**
         * HACK: It seems props arent immediately ready
         * when the page loads so we watch for changes
         */
        watch(
            [() => props.filters, () => props.processresults],
            ([newFilters, newProcessResults]) => {
                if (Array.isArray(newFilters)) {
                    filters.value = newFilters;
                }

                if (typeof newProcessResults === 'function') {
                    processResults.value = newProcessResults;
                }

                loading.value = false;
            },
            { immediate: true }
        );

        return {
            filters: filters,
            loading: loading,
            processResults: processResults,
        }
    },
});
</script>
